import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	footer: {
		background: theme?.palette?.background?.footer,
		color: "#FFFFFF",
		marginTop: "auto"
	},
	container: {
		maxWidth: 1376,
		padding: theme.spacing(5, 3, 3),
		[theme.breakpoints.up("lg")]: {
			padding: theme.spacing(6, 3, 5)
		}
	}
}));

export default styles;
